import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.sort";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useRef, useEffect, useState } from 'react';
import ReactEcharts from 'echarts-for-react';
import clsx from 'clsx';
import i18n from '@pureartisan/simple-i18n';
import { Tooltip } from 'reactstrap';
import { CPAL_METRICS, CPAL_FEEDERS, CPAL_FEEDER_TIP_ITEMS } from './../../../../constants/metrics';
import { CRI_COLORS, ECON_COLORS, EDU_COLORS, FAM_COLORS, HEL_COLORS, COMM_COLORS, FEEDER_ACTIVE } from './../../../../constants/colors';
import useStore from './../store';
import { getMetric, getRoundedValue, toTitleCase } from './../utils';
import { schools } from './../../../../data/schools';

var FeederChart = function FeederChart(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]); // Generic state updates for store.
  // Accepts an object of values to update.


  var setStoreValues = useStore(function (state) {
    return state.setStoreValues;
  }); // Currently active (hovered) feeder
  // Stores the SLN of the feeder

  var activeFeeder = useStore(function (state) {
    return state.activeFeeder;
  }); // Whether feeder is "locked" by click

  var feederLocked = useStore(function (state) {
    return state.feederLocked;
  }); // Track whether mobile.

  var interactionsMobile = useStore(function (state) {
    return state.interactionsMobile;
  });

  var getBarBgColor = function getBarBgColor(el) {
    // console.log('getBarBgColor', el)
    // If active feeder, return that color
    if (Number(activeFeeder) === Number(el.id)) {
      return FEEDER_ACTIVE;
    } else {
      // Else return the color for the standard deviation
      return CRI_COLORS[el.sd];
    }
  };
  /**
   * Gets the set of schools that are in a feeder
   * @return Array Array of school data objects
   */


  var getSchoolSet = function getSchoolSet(feeder) {
    return schools.filter(function (el) {
      return el.HIGH_SLN === feeder;
    });
  };

  var getFeederAverage = function getFeederAverage(metric, schoolSet) {
    // Get all the schools that are in that
    // console.log('getFeederAverage, ', schoolSet)
    var values = [];
    schoolSet.forEach(function (el) {
      values.push(el[metric]);
    });
    var total = 0;
    values.forEach(function (v) {
      return total = total + v;
    });
    return total / values.length;
  };

  var getFeederSDAverage = function getFeederSDAverage(metric, schoolSet) {
    // Get all the schools that are in that
    // console.log('getFeederAverage, ', schoolSet)
    var values = [];
    schoolSet.forEach(function (el) {
      values.push(el[metric + '_sd']);
    });
    var total = 0;
    values.forEach(function (v) {
      return total = total + v;
    });
    return Math.round(total / values.length);
  };
  /**
   * Builds feeder bar chart data set.
   * @return Array Array of objects
   */


  var buildFeederData = function buildFeederData() {
    // console.log('buildFeederData, ', CPAL_FEEDERS)
    var feederData = [];
    CPAL_FEEDERS.forEach(function (el) {
      feederData.push({
        name: el.title,
        id: el.id,
        label: el.title,
        value: getFeederAverage('cri_weight', getSchoolSet(el.id)),
        sd: getFeederSDAverage('cri_weight', getSchoolSet(el.id))
      });
    }); // Sort ascending by cri average

    feederData.sort(function (a, b) {
      return a.value - b.value;
    });
    return feederData;
  }; // buildFeederData()


  var onFeederMouseover = function onFeederMouseover(e) {
    // console.log('onFeederMouseover, ', e.currentTarget.id)
    var feeder = String(e.currentTarget.id).replace('feeder_bar_', '');

    if (!feederLocked) {
      setStoreValues({
        activeFeeder: feeder
      });
    }
  };

  var onFeederMouseout = function onFeederMouseout(e) {
    // console.log('onFeederMouseout, ', e.currentTarget.id)
    if (!feederLocked) {
      setStoreValues({
        activeFeeder: null
      });
    }
  };

  var onFeederClick = function onFeederClick(e) {
    // console.log('onFeederClick, ', e.currentTarget.id)
    setStoreValues({
      highlightedSchool: ''
    });
    var feeder = String(e.currentTarget.id).replace('feeder_bar_', '');

    if (!!feederLocked && Number(activeFeeder) === Number(feeder)) {
      setStoreValues({
        activeFeeder: null,
        feederLocked: false
      });
    } else {
      setStoreValues({
        activeFeeder: feeder,
        feederLocked: true
      });
    }
  };

  var feederChartReady = function feederChartReady(e) {// console.log('feeder chart ready')
  };

  var feederEvents = {
    mouseover: onFeederMouseover,
    mouseout: onFeederMouseout,
    click: onFeederClick
  }; // For each bar, a button. Includes the name and value.

  return /*#__PURE__*/React.createElement("div", {
    className: "feeder-chart-bar",
    "aria-label": i18n.translate('UI_FEEDER_FEEDER_CHART_DESC')
  }, /*#__PURE__*/React.createElement("div", {
    className: "feeder-chart-header"
  }, /*#__PURE__*/React.createElement("h2", null, "Dallas ISD School Feeder Patterns")), children, buildFeederData().map(function (el) {
    // console.log('building feeder data, ', el)
    // to manage tooltip state
    var _useState = useState(false),
        tooltipOpen = _useState[0],
        setTooltipOpen = _useState[1];

    var toggle = function toggle() {
      return setTooltipOpen(!tooltipOpen);
    };

    return /*#__PURE__*/React.createElement("button", {
      id: 'feeder_bar_' + el.id,
      key: 'feeder_bar_' + el.id,
      className: clsx('feeder-bar-button', Number(el.id) === Number(activeFeeder) ? 'active' : ''),
      onClick: onFeederClick,
      onMouseOver: onFeederMouseover,
      onMouseOut: onFeederMouseout
    }, /*#__PURE__*/React.createElement("span", {
      className: "label"
    }, el.label), /*#__PURE__*/React.createElement("div", {
      id: 'bar_' + el.id,
      className: "bar",
      style: {
        width: getRoundedValue(el.value, 0, 1) + '%',
        backgroundColor: getBarBgColor(el) // conditional based on

      },
      "aria-hidden": "true"
    }, !interactionsMobile && /*#__PURE__*/React.createElement(Tooltip, {
      key: 'feeder_bar_tip_' + el.id,
      placement: "auto",
      isOpen: tooltipOpen,
      target: 'bar_' + el.id,
      toggle: toggle,
      trigger: "hover"
    }, i18n.translate('FEEDER_UI_CLICK_FOR_ADDL'))), /*#__PURE__*/React.createElement("span", {
      className: "data"
    }, getRoundedValue(el.value, 0, 1)));
  }));
};

export default FeederChart;